module.exports = __webpack_public_path__ + "img/quizmayhem_banner_1950s.8e6c3068.jpg";